import React, { useState } from 'react';
import { SxStyle } from '../../../../types';
import Stack from '@mui/material/Stack';
import AppMenuItemHeader from './app-menu-item-header';
import AppMenuItemEdit from './app-menu-item-edit';
import { EditableBottomBarItem, MenuItemEditableKeys } from '../types';
import { InputWithValidateProps } from '../../../common/input/text-input-with-validate';
import { AnySchema } from 'yup';

const styles: SxStyle = {
  container: {},
  active: {
    opacity: 0,
  },
  expanded: {
    height: 'auto',
  },
};

export interface AppMenuItemBoxProps extends Pick<InputWithValidateProps, 'onValidation'> {
  bottomBarItem: EditableBottomBarItem;
  position?: number;
  listeners?: any;
  isDragging?: boolean;
  isActive?: boolean;
  isExpanded?: boolean;
  onExpanded?: (expanded: boolean) => void;
  onDelete?: (menuItem: EditableBottomBarItem) => void;
  onSave?: (menuItem: EditableBottomBarItem) => void;
  onValue?: (key: MenuItemEditableKeys, value: any | null) => void;
}

const AppMenuItem = ({
  bottomBarItem,
  position,
  listeners,
  isDragging,
  isActive,
  isExpanded = false,
  onExpanded,
  onDelete,
  onSave,
  onValue,
  onValidation,
}: AppMenuItemBoxProps) => {
  const [isValid, setIsValid] = useState(true);

  const styling = {
    ...styles.container,
    ...(isExpanded ? styles.expanded : {}),
    ...(isActive ? styles.active : {}),
  };

  const handleValidation = (key: string, isValid: boolean, schema?: AnySchema) => {
    setIsValid(isValid);
    onValidation && onValidation(key, isValid, schema);
  };

  return (
    <Stack sx={styling} spacing={1}>
      <AppMenuItemHeader
        bottomBarItem={bottomBarItem}
        position={position}
        isExpanded={isExpanded}
        onExpanded={onExpanded}
        isDragging={isDragging}
        listeners={listeners}
        isValid={isValid}
      />
      {isExpanded && (
        <AppMenuItemEdit
          bottomBarItem={bottomBarItem}
          onDelete={onDelete}
          onSave={onSave}
          onValue={onValue}
          onValidation={handleValidation}
        />
      )}
    </Stack>
  );
};

export default AppMenuItem;
